import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { CookieKey } from 'src/app/domain/enums/cookies.enum';
import { CookieService } from 'src/app/services/cookies/cookie.service';
import { obterArquivoPoliticaPrivacidade, obterArquivoPoliticaPrivacidadeFinish } from 'src/app/stateManagement/actions/Sobre/obter-politica-privacidade.action';
import { ObterArquivoPoliticaPrivacidadeState } from 'src/app/stateManagement/reducers/Sobre/obter-politica-privacidade.reducer';
import { selectDadosObterArquivoPoliticaPrivacidade } from 'src/app/stateManagement/selectors/Sobre/obter-arquivo-politica-privacidade.selector';
import { FilesDeviceService } from 'src/app/services/devices/files-device.service';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.css',
  animations: [
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [
        animate('0.5s ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('0.5s ease-in', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class CookieBannerComponent implements OnInit, OnDestroy{

  public mostrarBanner = false;

  private subPoliticaPrivacidade = new Subscription();

  constructor(
    private filesDeviceServer: FilesDeviceService,
    private cookieService: CookieService,
    private readonly storeObterArquivoPoliticaPrivacidade: Store<{ obterArquivoPoliticaPrivacidadeState: ObterArquivoPoliticaPrivacidadeState }>) { }

  ngOnInit(): void {
    this.mostrarBanner = !this.cookieService.getCookie(CookieKey.NoticeAcknowledged);

    this.subPoliticaPrivacidade = this.storeObterArquivoPoliticaPrivacidade.select(selectDadosObterArquivoPoliticaPrivacidade)
      .subscribe(result => {
        if(result?.dados){
          this.filesDeviceServer.openOrDownloadPDF(result?.dados, 'PoliticaDePrivacidade');
        }
      });
  }

  ngOnDestroy(): void {
    this.subPoliticaPrivacidade.unsubscribe();
    this.storeObterArquivoPoliticaPrivacidade.dispatch(obterArquivoPoliticaPrivacidadeFinish());
  }

  public abrirPoliticasPrivacidade(): void {
    this.storeObterArquivoPoliticaPrivacidade.dispatch(obterArquivoPoliticaPrivacidade());
  }

  public adicionarCookie(): void {
    this.cookieService.setCookie(CookieKey.NoticeAcknowledged, 'true');
    this.mostrarBanner = false;
  }
}
